module.exports = "/templates/task.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/task.html
// module id = 466
// module chunks = 0